import useUser from '../../users/useUser';
import {RoleTypeName} from '../../users/users.types';
import {doesUserHaveRole} from '../utils/doesUserHaveRole';

export function useUserRole(role: RoleTypeName) {
  const {user} = useUser();

  return {
    hasRole: !!user ? doesUserHaveRole(user, role) : false,
  };
}
